export const API_BASE_URL = "https://api.spotlight-manager.de/api/v1";
//export const API_BASE_URL = "https://localhost:57923/api/v1";